import React, { useLayoutEffect, useRef } from 'react';
import { useRouter } from '../../components';
import { SiteLink } from '../../components';
import BottomDrawer from '../../components/bottomDrawer'
import { isMin } from '../../cssInJs'

export function BottomDock(props) {
  const links = [
    { url: '/products', title: 'PRODUCTS', icon: 'products-yolk.png', iconHover: 'products-white.png' },
    { url: '/warranty', title: 'WARRANTY', icon: 'warranty-yolk.png', iconHover: 'warranty-white.png' },
    { url: '/recipes', title: 'RECIPES', icon: 'recipes-yolk.png', iconHover: 'recipes-white.png' },
    { url: '/contact', title: 'CONTACT', icon: 'contact-yolk.png', iconHover: 'contact-white.png' }
  ];

  //const path = usePath();
  const { pathname } = useRouter();

  const isCurrent = (link) => {
    return pathname && pathname.toLowerCase() === link.toLowerCase();
  }

  const linkElts = links.map((link, index) =>
    <li key={index} className={`bottomMenu__li ${isCurrent(link.url) ? 'selected' : ''}`}>
      <SiteLink to={link.url} className={`bottomMenu__link bottomMenu__link--${index}`}>
        <div className="icon">
          <img className="normal" src={`/assets/navicons/${link.icon}`} alt={link.title} />
          <img className="selected" src={`/assets/navicons/${link.iconHover}`} alt={link.title} />
        </div>
        <div>{link.title}</div>
      </SiteLink>
    </li>
  );

  const bottomMenu = useRef(null);
  useLayoutEffect(() => {
    //console.log('useLayoutEffect');
    const slider = new BottomDrawer(bottomMenu.current, { status: isMin.md() ? 'collapsed' : 'expanded' });
    setTimeout(() => slider.init(), 1000)
  }, [])

  return (
    <>
      <nav className="bottomMenu" ref={bottomMenu}>
        <div className="bottomMenu__bar">
          <div className="bottomMenu__line1"></div>
          <div className="bottomMenu__line2"></div>
        </div>
        {/* <div className="bottomMenu__bg"></div> */}
        <ul className="bottomMenu__links">
          {linkElts}
        </ul>
      </nav>
      <div className="bottomMenuPadding"></div>
    </>
  );
}
